@if (subnavCollapsed || showSubnav) {
<div
  class="side-menu subnav"
  [class.subnav-collapsed]="subnavCollapsed"
  [class.mobile]="isMobile"
  [class.show]="isMobile && showSubnav"
  style="position: relative"
>
  @if (showSubnav) {

  <div class="subnav-padding subnav-padding-top">
    <div class="program-info-wrapper" style="position: relative">
      <button
        class="program-info-menu"
        id="program-switcher-trigger"
        type="button"
        (click)="onProgramInfoClick()"
        (keydown.enter.capture)="onProgramInfoClick($event)"
        [attr.aria-expanded]="isProgramSwitcherVisible"
        [attr.aria-label]="getProgramInfoAriaLabel()"
        aria-haspopup="true"
        aria-controls="program-switcher-menu"
        aut-id="program-switcher-btn"
      >
        <div class="program-info-content">
          <div class="program-info-text">
            <div class="program-info-title">{{ currentProgramName }}</div>
            <div class="program-info-type">{{ currentProgramType }}</div>
          </div>
          <span class="program-info-arrow">
            @if (isProgramSwitcherVisible) {
            <i class="icon icon-md icon-chevron-up"></i>
            } @if (!isProgramSwitcherVisible) {
            <i class="icon icon-md icon-chevron-down"></i>
            }
          </span>
        </div>
      </button>
    </div>
  </div>
  <div class="subnav-padding">
    <nav neo-vertical-nav aria-label="Program Menu">
      @for (item of verticalNavItems; track item; let i = $index) { @if (!item.children) {
      <button
        neo-vertical-nav-item
        type="button"
        (click)="onVerticalNavItemClick(item, undefined)"
        (keydown.enter)="onVerticalNavItemClick(item, undefined)"
        [attr.aut-id]="'sub-nav-item-' + item.autId"
        [id]="'subnav-item-' + item.label"
        [attr.aria-current]="isMenuItemActive(item) ? 'page' : null"
        [ngClass]="{ 'neo-vertical-nav-item-selected': isMenuItemActive(item) }"
      >
        {{ item.label }}
      </button>
      } @if (item.children) {
      <neo-accordion>
        <neo-expansion-panel [expanded]="isParentExpanded(i)">
          <neo-expansion-panel-header [attr.aut-id]="'sub-nav-item-' + item.autId">
            <neo-panel-title> {{ item.label }} </neo-panel-title>
          </neo-expansion-panel-header>
          <div class="subnav-children">
            @for (child of item.children; track child) {
            <button
              neo-vertical-nav-item
              type="button"
              (click)="onVerticalNavItemClick(child, i)"
              (keydown.enter)="onVerticalNavItemClick(child, i)"
              [id]="'subnav-item-' + child.label"
              [attr.aut-id]="'sub-nav-item-' + child.autId"
              [attr.aria-current]="isMenuItemActive(child) ? 'page' : null"
              [ngClass]="{ 'neo-vertical-nav-item-selected': isMenuItemActive(child) }"
            >
              {{ child.label }}
            </button>
            }
          </div>
        </neo-expansion-panel>
      </neo-accordion>
      } }
    </nav>
  </div>

  } @if (!isMobile && !layoutService.showProgramSwitcher) {
  <toggle-arrow-btn
    class="subnav-toggle-btn"
    [direction]="subnavCollapsed ? 'right' : 'left'"
    [size]="32"
    ariaLabel="Toggle Subnavigation Menu"
    [expanded]="!subnavCollapsed"
    [autId]="'subnav-toggle-btn'"
    (clicked)="toggleCollapse()"
  ></toggle-arrow-btn>
  }
</div>
}
